import Vue from 'vue'
import Vuex from 'vuex'
import banner from './modules/api/banner'
import sponsor from './modules/api/sponsor'
import about from './modules/api/about'
import creativity from './modules/api/creativity'
import news from './modules/api/news'
import winners from './modules/api/winners'
import program from './modules/api/program'
import gallery from './modules/api/gallery'
import awards from './modules/api/awards'
import archive from './modules/api/archive'

import nav from './modules/components/nav'
import constants from './modules/components/constants'
import symposium from './modules/api/symposium'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    banner,
    sponsor,
    about,
    creativity,
    news,
    winners,
    program,
    gallery,
    awards,
    archive,
    nav,
    constants,
    symposium
  }
})
